import { TableModel, tableModelFactory } from "../table-model-factory";

export interface EnrollmentActivitySummaryByDayModel extends TableModel {}

export function getEnrollmentActivitySummaryByDayModel(): EnrollmentActivitySummaryByDayModel {
  return {
    ...tableModelFactory(
      "enrollmentActivitySummaryByDay",
      "enrollment_activity_summary_by_day/last_7_days",
      getEnrollmentActivitySummaryByDayRowId
    ),
  };
}

function getEnrollmentActivitySummaryByDayRowId(row) {
  return [row.eLMSID.toString(), row.activity_start_day.toString()].join("|");
}
